React = require 'react'
{ PropTypes } = React
{ connect } = require 'react-redux'
{ fetchClassrooms, fetchClassroom } = require '../actions/classrooms'
SelectClassroomComponent = require '../components/SelectClassroom'

SelectClassroom = React.createClass
	displayName: 'SelectClassroom'
	propTypes:
		classrooms: PropTypes.array
		feedback: PropTypes.object
		fetchClassrooms: PropTypes.func.isRequired
		isFetching: PropTypes.bool
		reduxFormProps: PropTypes.object
		requireSchoolId: PropTypes.bool
		selectedSchool: PropTypes.object
		selectedClassroom: PropTypes.object
		fetchClassroom: PropTypes.func.isRequired
		# Set `shouldFetchClassrooms` to false to prevent this component from fetching its own data.  Defaults to true
		shouldFetchClassrooms: PropTypes.bool

	render: ->
		React.createElement(SelectClassroomComponent, { \
			"classrooms": ( @props.classrooms ),  \
			"feedback": ( @props.feedback ),  \
			"fetchClassrooms": ( @props.fetchClassrooms ),  \
			"isFetching": ( @props.isFetching ),  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"requireSchoolId": ( @props.requireSchoolId ),  \
			"selectedSchoolId": ( @props.selectedSchool?.id ),  \
			"selectedClassroomId": ( @props.selectedClassroom?.id ),  \
			"fetchClassroom": ( @props.fetchClassroom ),  \
			"shouldFetchClassrooms": ( @props.shouldFetchClassrooms )
		})

mapStateToProps = (state) ->
	classrooms: state.classrooms.list
	isFetching: state.classrooms.isFetching
	selectedSchool: state.schools.selected
	selectedClassroom: state.classrooms.selected

mapDispatchToProps = {
	fetchClassrooms
	fetchClassroom
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(SelectClassroom)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/containers/SelectClassroom.cjsx